import React, { useEffect, useState } from 'react';

export default function StickySearchBar({ value, onChange, onSubmit, isLoading, visible }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!visible) {
      setShow(false);
      return undefined;
    }

    const target = document.getElementById('search-anchor');
    if (!target) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0, rootMargin: '-8px 0px 0px 0px' }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [visible]);

  if (!show) return null;

  return (
    <div className="sticky-search" role="search" aria-label="ค้นหาด่วน">
      <form
        className="sticky-search__form"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <input
          type="search"
          className="sticky-search__input"
          placeholder="ฝันว่า ???"
          value={value}
          onChange={onChange}
          aria-label="ค้นหาความฝันหรือเลขเด็ด"
        />
        <button
          type="submit"
          className="sticky-search__btn"
          disabled={isLoading || !value?.trim()}
        >
          {isLoading ? '...' : 'ค้นหา'}
        </button>
      </form>
    </div>
  );
}
